import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IOrganizationNameDto } from '@/dtos';

export const GET_ORGANIZATION_NAME = 'GET_ORGANIZATION_NAME';

interface Props {
  id?: string;
  enabled?: boolean;
}

const useGetOrgName = (props: Props) => {
  const { id, enabled } = props;
  const { isLoading, data } = useQuery(
    [GET_ORGANIZATION_NAME, id],
    () => api.get<IOrganizationNameDto>(API_URL.ORGANIZATIONS_NAME_BY_ID(id || '')),
    {
      enabled: Boolean(id && enabled),
    }
  );

  return {
    name: data?.data?.name,
    data: data?.data,
    isLoading,
  };
};

export default useGetOrgName;
